module.exports = __webpack_public_path__ + "img/doorbC2.34cb9b26.png";